/* External */
import { memo } from 'react';

/* Ott-common */
import SkeletonCommon from '@dtvgo/skeleton';

/* Styles */
import './DetailSkeleton.scss';

/* Static skeleton for the content-detail (PDP) pages — VOD, Show and Live.
   It mirrors the DetailContainer/Vod layout (full-screen backdrop, the
   bottom-left content column with title / subtitle / description / action
   buttons, and the tab bar pinned to the bottom edge) so the swap into the
   real page is seamless. It is the "detail" counterpart of LanderSkeleton:
   the route-loading shell (Private.jsx) renders it while a detail route's
   chunk loads, and the PDP pages render it while their content entity is
   still fetching — so a route change never shows a second, unrelated
   loading screen (the old centered "Carregando conteúdo" + spinner). */
function DetailSkeleton() {
  return (
    <div className="dtv-html5-c-detail-skeleton">
      <SkeletonCommon className="dtv-html5-c-detail-skeleton__backdrop" />
      <div className="dtv-html5-c-detail-skeleton__content">
        <SkeletonCommon className="dtv-html5-c-detail-skeleton__title" />
        <SkeletonCommon className="dtv-html5-c-detail-skeleton__subtitle" />
        <div className="dtv-html5-c-detail-skeleton__description">
          <SkeletonCommon className="dtv-html5-c-detail-skeleton__description-line" />
          <SkeletonCommon className="dtv-html5-c-detail-skeleton__description-line dtv-html5-c-detail-skeleton__description-line--short" />
        </div>
        <div className="dtv-html5-c-detail-skeleton__buttons">
          <SkeletonCommon className="dtv-html5-c-detail-skeleton__button dtv-html5-c-detail-skeleton__button--primary" />
          <SkeletonCommon className="dtv-html5-c-detail-skeleton__button" />
          <SkeletonCommon className="dtv-html5-c-detail-skeleton__button" />
        </div>
      </div>
      <div className="dtv-html5-c-detail-skeleton__tabs">
        <SkeletonCommon className="dtv-html5-c-detail-skeleton__tab" />
        <SkeletonCommon className="dtv-html5-c-detail-skeleton__tab" />
      </div>
    </div>
  );
}

export default memo(DetailSkeleton);
